import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import FoodPackageForm from './FoodPackageForm'

const FoodPackageCreate: React.FC = () => (
  <SectionWrapper title={'resources.foodpackages.createPackage'}>
    <Create>
      <FoodPackageForm />
    </Create>
  </SectionWrapper>
)

export default FoodPackageCreate
